import { useMutation } from "@tanstack/react-query";
import { contestantService } from "~shared/lib/api/services/contestant.service";

export function useSearchMembers() {
  const {
    mutate: searchMembers,
    data: members,
    isPending,
    error,
    reset,
  } = useMutation({
    mutationFn: (full_name: string) =>
      contestantService.searchByFullName(full_name),
  });

  return { searchMembers, members, isPending, error, reset };
}
